// extracted by mini-css-extract-plugin
export default {"container":"StylesGeneral_container__5hzBe","containerButtons":"StylesGeneral_containerButtons__Ionnz"};